'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ListGridConstants
 * @description
 * # ListGridConstants
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ListGridConstants', function () {

      var constants = {};

      constants.Types = {
          Dashboard: { name: 'Dashboard', requestMethod: 'Home' },
          Setup: { name: 'Setup', requestMethod: 'ListGrid' }
      };

      constants.EditType = {
          INLINE: 'Single',
          DIALOG: 'Dialog'
      };

      constants.Mode = {
          NONE: 'None',
          ADD: 0,
          EDIT: 1,
          DELETE: 2
      };

      constants.SetupMode = {
          LISTGRID: 'listGrid',
          PROFILE: 'profile'
      };

      constants.Operation = {
          INSERT: 0,
          EDIT: 1,
          DELETE: 2
      };
	  
	  constants.DialogDisplayTypes = {
          COLUMN: 'COLUMN',
          STACKED: 'STACKED'
      };

      constants.SectionType = {
          Grid: 0,
          Dashboard: 1,
          GeneralPage: 2,
          Report: 3,
          Calendar: 4
      };

      constants.ButtonActions = {
          Execute: 'EXECUTE',
          OpenPage: 'OPENPAGE',
          OpenDialog: 'OPENDIALOG',
          Recurrence: 'RECURRENCE',
          DataCollections: 'DATACOLLECTION'
      };

      constants.NumberDisplayTypes = {
          Percent: 'percent',
          ProgressBar: 'progressBar',
          DurationSplit: 'durationSplit'
      };

      constants.oneLogin = {
          contactsPageID: '400111',
      };

      constants.GridsContainingRoomHistory = {
        Racks: '401138',
        ScheduledActivities: '401140'
      }

      constants.RoomHistoryFilteringRecordProperties = {
        Racks: { fieldName: 'HIDE_RACK_BY_DSC', displayName: 'HIDE_RACK_BY_DSC_'},
        ScheduledActivities: { fieldName: 'HIDE_RMACT_BY_DSC', displayName: 'HIDE_RMACT_BY_DSC_'}
      }

      return constants;

  });